// extracted by mini-css-extract-plugin
export default {"pageContent":"PageContent_pageContent__N55eA"};